/**
 * navOpen.js
 * Handles toggling off-screen navigation
 *
 */
export default class navigation {

    constructor() {

        this.settings = {
            navOpen: document.getElementById('navigation-open'),
            navClose: document.getElementById('navigation-close'),
            body: document.getElementsByTagName('body')[0],
            site: document.getElementById('page'),
            activeClass: 'js-nav-open',
            overlayClass: 'js-overlay-active',
            subNav: document.getElementById('subpage-dropdown'),
            subMenuClass: 'js-sub-nav-open',
            subMenuActiveClass: "is-active"
        }

    }

    init() {

        if (null !== this.settings.navOpen) {
            this.bindUIActions();
        }

    }

    bindUIActions() {

        const { navOpen, navClose, megaMenuToggle, megaMenus, body, site, activeClass, menuClass, overlayClass, subNav } = this.settings;

        // Close mobile menu if screen is resized up
        window.addEventListener('resize', () => {
            if (window.innerWidth > 899) {
                this.navClassSwitcher('remove');

                const allButtons = document.querySelectorAll('.navigation__button--active');

                allButtons.forEach(button => {
                    button.classList.remove('navigation__button--active');
                    button.parentElement.querySelector('.mega-menu').classList.remove('mega-menu--active');
                    button.setAttribute('aria-expanded', 'false');
                })

            }
        })

        // Open nav on click on button
        navOpen.addEventListener('click', (e) => {

            this.navClassSwitcher();
        });

        // Close nav on click close button
        navClose.addEventListener('click', (e) => {
            this.navClassSwitcher('remove');
        });

        if (subNav) {

            subNav.querySelector('.subpages__toggle').addEventListener('click', (e) => {
                this.subNavSwitcher(e.target);
            });

        }

    }

    navClassSwitcher(status) {

        const { navOpen, navClose, megaMenuToggle, megaMenus, body, activeClass, menuClass, subNav, subMenuClass, subMenuActiveClass } = this.settings;

        const subMenus = document.querySelectorAll('.navigation__nav-item--sub-menu');

        if (body.classList.contains(activeClass)) {
            body.classList.remove(activeClass);
            body.classList.remove(subMenuClass);

            subMenus.forEach(menu => {
                menu.classList.remove(subMenuActiveClass);
            })

        } else if ('remove' === status) {
            body.classList.remove(activeClass);
            body.classList.remove(subMenuClass);

            subMenus.forEach(menu => {
                menu.classList.remove(subMenuActiveClass);
            })

        } else {
            body.classList.add(activeClass);
        }

    }

    menuClassSwitcher(el, status) {

        const { navOpen, navClose, megaMenuToggle, megaMenus, body, site, activeClass, menuClass, overlayClass, subNav } = this.settings;

        const allMenus = megaMenus;

        // Get all mega menu buttons (1) and remove all active classes on them (2)
        // unless it's the currently active one being clicked (3)
        // Then deal with currently active one (4)

        // (1)
        const allButtons = document.querySelectorAll('.navigation__button--active');

        // (2)
        allButtons.forEach(button => {
            // (3)
            if (!el.getElementsByTagName('button')[0].isSameNode(button)) {
                button.classList.remove('navigation__button--active');
                button.parentElement.querySelector('.mega-menu').classList.remove('mega-menu--active');
                button.setAttribute('aria-expanded', 'false');
                body.classList.remove(menuClass);
            }
        })

        // (4)
        if (!el.getElementsByTagName('button')[0].classList.contains('navigation__button--active')) {
            el.getElementsByTagName('button')[0].classList.add('navigation__button--active');
            el.querySelector('.mega-menu').classList.add('mega-menu--active');
            el.getElementsByTagName('button')[0].setAttribute('aria-expanded', 'true');
            body.classList.add(menuClass, overlayClass);
        } else {
            el.getElementsByTagName('button')[0].classList.remove('navigation__button--active');
            el.querySelector('.mega-menu').classList.remove('mega-menu--active');
            el.getElementsByTagName('button')[0].setAttribute('aria-expanded', 'false');
            body.classList.remove(menuClass, overlayClass);
        }

        body.classList.remove('js-search-open');

    }

    subNavSwitcher(el) {

        const { navOpen, navClose, megaMenuToggle, megaMenus, body, activeClass, menuClass, subNav } = this.settings;

        if (subNav.classList.contains(activeClass)) {
            subNav.classList.remove(activeClass);
            el.setAttribute('aria-expanded', 'false');
        } else {
            subNav.classList.add(activeClass);
            el.setAttribute('aria-expanded', 'true');
        }
    }

}
